import React, { useState, useEffect } from 'react'
import { Collapse, Tab, Tabs } from 'react-bootstrap'
import AresNavBar from '../Layout/NavBar/NavBar'
import SideBar from '../Layout/SideBar/SideBar'
import RouteMap from './Device/RouteMap'
import axios from '../../services/Api'
import Geocode from "react-geocode";
import { ModalManager } from 'react-dynamic-modal';

import './index.css'
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai'
import RoutesList from './RoutesList'
import MarksList from './MarksList'
import { Spinner } from 'react-bootstrap';
import DeviceList from './Device/DeviceList'
import swal from 'sweetalert';
import ConfigModal from './config'
import DefaultModal from '../Util/Modal'
import { get } from '../../utils/Storage'
import { downloadReport } from '../../utils/Report'

Geocode.setApiKey("AIzaSyB5-gkjdWxrp03tbm_Mq0RalCYog1VF0U4");

export default function Travel() {
  const [history, setHistory] = useState([]);
  const [device, setDevice] = useState(null);
  const [deviceName, setDeviceName] = useState('');
  const [deviceList, setDeviceList] = useState(null)
  const [selectedTravel, setSelectedTravel] = useState(false);
  const [travelList, setTravelList] = useState([]);
  const [travel, setTravel] = useState([]);
  const [travelID, setTravelID] = useState(null);
  const [key, setKey] = useState('routes');
  const [showInfo, setShowInfo] = useState(false)
  const [openRoutes, setOpenRoutes] = useState(true);
  const [coordinates, setCoordinates] = useState([]);
  const [isRoute, setIsRoute] = useState(false);
  const [mapHidden, setMapHidden] = useState(false);
  const [disableMarker, setDisableMarker] = useState(true);
  const [disableDevice, setDisableDevice] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const user = get('user')

  useEffect(() => {
    window.location.assign('#routes')
    init();
  }, []);

  useEffect(() => {
    switch (window.location.hash) {
      case '#routes':
        setKey('routes')
        setMapHidden(false)
        setShowInfo(false)
        setSelectedTravel(false)
        setIsRoute(false)
        setOpenRoutes(!openRoutes)
        break;
      case '#devices':
        setKey('devices')
        setMapHidden(true)
        break;
      case '#history':
        setKey('markers')
        break;
      default:
        break;
    }
  }, [window.location.hash]);

  async function init() {
    await getTravels();
  }

  /**
   * Fetch data
   */

  //Fetch travels list
  async function getTravels() {
    setLoading(true);
    try {
      const response = await axios.get('/api/travels?paginate=false');
      setTravelList(response.data.data);
      setLoading(false)
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", "Não foi possível localizar viagens", "error");
      setLoading(false)
    }
  }

  // Fetch history device history
  async function getMarkers(deviceID, loading) {
    const loadingType = loading == 'alert' ? 'alert' : 'loader';

    try {
      if (loadingType == 'loader')
        setLoading(true)
      const response = await axios.get(`/api/travels/${travelID}/devices/${deviceID}/history`);
      setHistory(response.data);
      if (loadingType == 'loader')
        setLoading(false)
      return response.data;
    } catch (e) {
      swal("Erro!", "Não foi possível localizar pontos", "error");
      if (loadingType == 'loader')
        setLoading(false)
    }
  }

  // Fetch devices and travel data
  async function getDevices(id) {
    try {
      const response = await axios.get(`/api/travels/${id}`);
      setTravel(response.data)
      setDeviceList(response.data.devices)
      setTravelID(id)
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", "Não foi possível encontrar dispositivos", "error");
    }
  }

  // Create and downloading device excel reports 
  async function getTravelReports(id, mac) {
    try {
      reportLoading();
      const response = await axios.get(`/api/travels/${id}/html`);
      await downloadReport(`/api/travel-report/files/${response.data._id}`, response.data.file);
      swal("Sucesso!", `Relátório foi baixado com sucesso`, "success");
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", e.response ? e.response.data.error : e.message, "error");
    }
  }

  // Create and downloading device excel reports 
  async function getExcelReports(id, mac) {
    try {
      reportLoading();
      const response = await axios.get(`/api/travels/${id}/devices/${mac}/history/excel`);
      await downloadReport(`/api/report/files/${response.data._id}`, response.data.file);
      swal("Sucesso!", `Relátório foi baixado com sucesso`, "success");
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", e.response ? e.response.data.error : e.message, "error");
    }
  }

  // Create and downloading device pdf reports 
  async function getPDFReports(id, mac) {
    try {
      reportLoading();
      const response = await axios.get(`/api/travels/${id}/devices/${mac}/history/pdf`);
      await downloadReport(`/api/report/files/${response.data._id}`, response.data.file);
      swal("Sucesso!", `Relátório foi baixado com sucesso`, "success");
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", e.response ? e.response.data.error : e.message, "error");
    }
  }

  async function getTravelRouteTraveled(travelId)
  {
    try{
      const response = await axios.get(`/api/travels/${travelId}/locations`);
      return response.data;
    }catch(e){
      console.log(e);
    }
  }


  // callback coordinates
  async function showRoute(data) {
    let coordinates = []
    console.log(data);

    coordinates.push({
      lat: data.origin.location[0],
      lng: data.origin.location[1]
    })
    coordinates.push({
      lat: data.destiny.location[0],
      lng: data.destiny.location[1]
    })

    const history = await getTravelRouteTraveled(data._id);

    ModalManager.open(<DefaultModal title="Trajeto" component={
    <RouteMap
      coordinates={coordinates}
      isRoute={true}
      routeHistory={history}
      selectedTravel={true}
      travel={data} />
    } />)
  }

  // callback markers list 
  async function routeMarkers(data, key) {
    switch (key) {
      case 'markers':
        window.location.assign('#history')
        await getMarkers(data.mac)
        setDeviceName(data.name)
        setKey(key)
        setOpenRoutes(false)
        setMapHidden(false)
        setIsRoute(false)
        setSelectedTravel(true)
        setDisableDevice(false)
        setDisableMarker(false)
        break;
      case 'routes':
        setKey(key)
        setOpenRoutes(true)
        setMapHidden(false)
        setSelectedTravel(false)
        setIsRoute(false)
        setDisableDevice(false)
        break;
      default:
        break;
    }
  }

  // callback modal manager for graph and edit
  async function openChartDeviceModal(device, modal, travel) {
    switch (modal) {
      case 'graph':
        swal('Aguarde..', 'Carregando dados...', 'info');
        const history = await getMarkers(device.mac, 'alert');
        swal.close();
        ModalManager.open(<ConfigModal device={device} deviceData={history} status={modal} />)
        break;
      case 'settings':
        ModalManager.open(<DefaultModal title="Configurar Dispositivo" component={<ConfigModal device={device} status={modal} travel={travel} onSaveModalForm={onSave} />} />)
        break;
      default:
        break;
    }
  }

  async function routeDevices(data, key) {
    window.location.assign('#devices')
    await getDevices(data._id)
    setKey(key)
    setOpenRoutes(false)
    setMapHidden(true)
    setSelectedTravel(false)
  }

  async function routeReportGenerate(data, key) {
    // window.location.assign('#devices')
    await getTravelReports(data._id)
    setKey(key)
    setOpenRoutes(false)
    setMapHidden(true)
    setSelectedTravel(false)
    // CallReportGenerator here...
  }
  
  async function onSave(data) {
    await getDevices(data._id)
    ModalManager.close()
    swal("Sucesso!", `Dispositivo foi atualizaddo com sucesso`, "success");
  }

  function markerDevice(data) {
    setDevice(data)
    setShowInfo(true)
  }

  function exportDeviceReports(id, mac, fileType) {
    switch (fileType) {
      case 'excel':
        getExcelReports(id, mac)
        break;
      case 'pdf':
        getPDFReports(id, mac)
        break;
      default:
        break;
    }
  }

  function reportLoading() {
    swal({
      title: 'Aguarde...',
      showCancelButton: false,
      showCloseButton: false,
      showConfirmButton: false,
      text: 'O relatório está sendo gerado...'
    })
  }

  function renderLoading() {
    return (
      <div className="center-page">
        <Spinner animation="border" />
      </div>
    )
  }

  /**
  * Render components
  */
  function ControlledTabs() {
    return (
      <Tabs
        id="controlled-tab"
        activeKey={key}
        onSelect={(k) => {
          setKey(k)
          switch (k) {
            case 'routes':
              setMapHidden(false)
              setShowInfo(false)
              setSelectedTravel(false)
              setIsRoute(false)
              setOpenRoutes(!openRoutes)
              window.location.assign('#routes')
              break;
            case 'devices':
              setMapHidden(true)
              setSelectedTravel(false)
              setDisableDevice(false)
              setShowInfo(false)
              window.location.assign('#devices')
              break;
            case 'markers':
              setMapHidden(false)
              setSelectedTravel(true)
              setIsRoute(false)
              setShowInfo(false)
              window.location.assign('#history')
              break;
            default:
              break;
          }
        }}
        className="tabs-title"
      >
        <Tab eventKey="routes" title={
          <span> Lista de viagens</span>
        } disabled={isRoute}>
            <div style={{ marginTop: '1rem' }}>
              <RoutesList
                data={travelList}
                callbackRoutes={showRoute}
                callbackDevices={routeDevices}
                callbackReports={routeReportGenerate} />
            </div>
        </Tab>
        <Tab eventKey="devices" title={
          <span>Dispositivos</span>
        } disabled={disableDevice}>
          <div style={{ marginTop: '1rem' }} >
            {deviceList &&
              <DeviceList
                devices={deviceList}
                travel={travel}
                callbackDevices={routeMarkers}
                callbackModal={openChartDeviceModal}
                reportCallback={exportDeviceReports}
                user={user}
              />
            }
          </div>
        </Tab>
        <Tab eventKey="markers" title={
          <span>Histórico</span>
        } disabled={disableMarker}>
          <div style={{ marginTop: '1rem' }} >
            {history &&
              <MarksList
                data={history}
                travel={travel}
                deviceName={deviceName}
                markersCallback={markerDevice}
                reportCallback={exportDeviceReports} />
            }
          </div>
        </Tab>
      </Tabs>
    );
  }

  return (
    <div className="Travel sidenav-margin">
      <AresNavBar />
      <SideBar />

      <div className="content">
        <div className="container-header">
          <h1>Viagens</h1>
        </div>
        {loading ?
          renderLoading()
          :
          <>
            <div className="padding-tabs">
              {ControlledTabs()}
            </div>
            <hr id="route-map" className="anchor-map" />
          </>
        }
      </div>

    </div>
  )
}
